var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout01 = function SvgLogout01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EF4444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M11.625 6.03c-.03-.87-.134-1.414-.477-1.84-.49-.608-1.327-.8-3.003-1.182l-.75-.17c-2.546-.581-3.82-.872-4.67-.203-.85.668-.85 1.96-.85 4.541v3.648c0 2.582 0 3.873.85 4.541s2.124.378 4.67-.202l.75-.171c1.676-.383 2.514-.574 3.003-1.182.343-.426.446-.97.477-1.84M13.875 6.759s2.25 1.657 2.25 2.25-2.25 2.25-2.25 2.25m1.875-2.25H6.375"
  })));
};
export default SvgLogout01;